import { useDeviceType } from "@/hooks";
import { useApiStore, useComponentStore } from "@/store";
import { Divider, Drawer, Modal } from "antd";
import { close_button, CloseIcon } from "@/assets";
import "./style.css";
import { memo, useCallback } from "react";

const Component = () => {
  const state = useComponentStore();
  const { modal, px, py, setState: setModal } = state;
  const { setState, form } = useApiStore((state) => state);
  const { isMobile } = useDeviceType();

  const onCancelModal = useCallback(() => {
    if (modal.clearAll) {
      setModal("modal", { ...modal, open: false, children: undefined });
    } else {
      setState("payload", undefined);
      form?.resetFields();
      setModal("modal", { ...modal, open: false, children: undefined });
      setModal("componentSteps", 0);
    }
  }, [modal, setModal]);

  // Calculate responsive width
  const getResponsiveWidth = () => {
    if (!modal.width) return "90%";

    // For screens smaller than the modal width + padding, use percentage
    if (window.innerWidth <= modal.width + 100) {
      return "95%";
    }

    // Use the specified width but with constraints
    return Math.min(modal.width, window.innerWidth * 0.9);
  };

  return !isMobile ? (
    <Modal
      open={modal.open}
      onCancel={() => {}}
      width={getResponsiveWidth()}
      closable={false}
      footer={null}
      centered={true}
      className="responsive-modal"
      style={{
        maxWidth: "95vw",
        top: 20,
      }}
      styles={{
        body: {
          maxHeight: "calc(90vh - 100px)",
          overflowY: "auto",
          overflowX: "auto",
          padding: "0",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        },
        content: {
          maxHeight: "90vh",
        },
      }}
    >
      <section
        className={`flex flex-col gap-2`}
        style={{
          padding:
            px !== undefined && py !== undefined
              ? `${px}px ${py}px`
              : undefined,
        }}
      >
        <header className="flex justify-between items-center sticky top-0 bg-white z-10 ">
          <div className="pr-6 text-lg">{modal?.title}</div>
          {modal.showCloseButton && (
            <div
              className="cursor-pointer rounded-full p-1 border-[#ff0000] border-[1px] shrink-0"
              onClick={onCancelModal}
            >
              <CloseIcon width={8} height={8} color={"red"} />
            </div>
          )}
        </header>
        {modal.isDetails && <Divider className="w-[110%] -mx-[5%] mb-0 mt-0" />}
        <main className="flex-1 overflow-y-auto overflow-x-auto scrollbar-hidden">
          {" "}
          {modal.children ?? <></>}
        </main>
      </section>
    </Modal>
  ) : (
    <Drawer
      placement={"bottom"}
      onClose={() => modal.toogle()}
      open={modal.open}
      closable={false}
      className="rounded-3xl"
      height="90%"
      styles={{
        body: {
          maxHeight: "80vh",
          overflowY: "auto",
          overflowX: "auto",
          padding: "12px 8px",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        },
      }}
    >
      <section className="flex flex-col gap-1 h-full">
        <header className="flex justify-between items-end shrink-0 sticky top-0 bg-white z-10 pb-1">
          <div>{modal?.title}</div>
          {modal.showCloseButton && (
            <img
              onClick={() => modal.toogle()}
              src={close_button}
              alt=""
              width={25}
              className="cursor-pointer "
            />
          )}
        </header>
        <main className="flex-1 overflow-y-auto overflow-x-auto scrollbar-hidden">
          {" "}
          {modal.children ?? <></>}
        </main>
      </section>
    </Drawer>
  );
};

export const PageModal = memo(Component);
